import { STOCK_BAJO } from '../config';
import { getNegocioId } from '../services/negocioActual';

// "Stock bajo" = quedan N o menos. Cada negocio elige su N (una boutique de
// piezas únicas no es igual que una distribuidora). Se guarda en este
// navegador por negocio; si no hay nada guardado se usa STOCK_BAJO.
const clave = () => `kontrol.umbralStock.${getNegocioId() || 'x'}`;

export const OPCIONES_UMBRAL = [0, 1, 2, 3, 5, 10, 20];

export function getUmbralStock() {
  try {
    const v = localStorage.getItem(clave());
    if (v != null && v !== '' && !Number.isNaN(Number(v))) return Number(v);
  } catch (e) { /* almacenamiento bloqueado: usar el de siempre */ }
  return STOCK_BAJO;
}

export function setUmbralStock(n) {
  try { localStorage.setItem(clave(), String(n)); } catch (e) { /* sin almacenamiento */ }
}

export const estaAgotado = (p) => !(Number(p.stock || 0) > 0);
export const esStockBajo = (p, umbral = getUmbralStock()) => Number(p.stock || 0) <= umbral;
